import { render, staticRenderFns } from "./hand.vue?vue&type=template&id=1cbb5b2e"
import script from "./hand.vue?vue&type=script&lang=js"
export * from "./hand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports